function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { e as elementChildren } from '../shared/utils.mjs';
function Parallax(_ref) {
  var swiper = _ref.swiper,
    extendParams = _ref.extendParams,
    on = _ref.on;
  extendParams({
    parallax: {
      enabled: false
    }
  });
  var elementsSelector = '[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]';
  var setTransform = function setTransform(el, progress) {
    var rtl = swiper.rtl;
    var rtlFactor = rtl ? -1 : 1;
    var p = el.getAttribute('data-swiper-parallax') || '0';
    var x = el.getAttribute('data-swiper-parallax-x');
    var y = el.getAttribute('data-swiper-parallax-y');
    var scale = el.getAttribute('data-swiper-parallax-scale');
    var opacity = el.getAttribute('data-swiper-parallax-opacity');
    var rotate = el.getAttribute('data-swiper-parallax-rotate');
    if (x || y) {
      x = x || '0';
      y = y || '0';
    } else if (swiper.isHorizontal()) {
      x = p;
      y = '0';
    } else {
      y = p;
      x = '0';
    }
    if (x.indexOf('%') >= 0) {
      x = "".concat(parseInt(x, 10) * progress * rtlFactor, "%");
    } else {
      x = "".concat(x * progress * rtlFactor, "px");
    }
    if (y.indexOf('%') >= 0) {
      y = "".concat(parseInt(y, 10) * progress, "%");
    } else {
      y = "".concat(y * progress, "px");
    }
    if (typeof opacity !== 'undefined' && opacity !== null) {
      var currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
      el.style.opacity = currentOpacity;
    }
    var transform = "translate3d(".concat(x, ", ").concat(y, ", 0px)");
    if (typeof scale !== 'undefined' && scale !== null) {
      var currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
      transform += " scale(".concat(currentScale, ")");
    }
    if (rotate && typeof rotate !== 'undefined' && rotate !== null) {
      var currentRotate = rotate * progress * -1;
      transform += " rotate(".concat(currentRotate, "deg)");
    }
    el.style.transform = transform;
  };
  var setTranslate = function setTranslate() {
    var el = swiper.el,
      slides = swiper.slides,
      progress = swiper.progress,
      snapGrid = swiper.snapGrid,
      isElement = swiper.isElement;
    var elements = elementChildren(el, elementsSelector);
    if (swiper.isElement) {
      elements.push.apply(elements, _toConsumableArray(elementChildren(swiper.hostEl, elementsSelector)));
    }
    elements.forEach(function (subEl) {
      setTransform(subEl, progress);
    });
    slides.forEach(function (slideEl, slideIndex) {
      var slideProgress = slideEl.progress;
      if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') {
        slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
      }
      slideProgress = Math.min(Math.max(slideProgress, -1), 1);
      slideEl.querySelectorAll("".concat(elementsSelector, ", [data-swiper-parallax-rotate]")).forEach(function (subEl) {
        setTransform(subEl, slideProgress);
      });
    });
  };
  var setTransition = function setTransition(duration) {
    if (duration === void 0) {
      duration = swiper.params.speed;
    }
    var el = swiper.el,
      hostEl = swiper.hostEl;
    var elements = _toConsumableArray(el.querySelectorAll(elementsSelector));
    if (swiper.isElement) {
      elements.push.apply(elements, _toConsumableArray(hostEl.querySelectorAll(elementsSelector)));
    }
    elements.forEach(function (parallaxEl) {
      var parallaxDuration = parseInt(parallaxEl.getAttribute('data-swiper-parallax-duration'), 10) || duration;
      if (duration === 0) parallaxDuration = 0;
      parallaxEl.style.transitionDuration = "".concat(parallaxDuration, "ms");
    });
  };
  on('beforeInit', function () {
    if (!swiper.params.parallax.enabled) return;
    swiper.params.watchSlidesProgress = true;
    swiper.originalParams.watchSlidesProgress = true;
  });
  on('init', function () {
    if (!swiper.params.parallax.enabled) return;
    setTranslate();
  });
  on('setTranslate', function () {
    if (!swiper.params.parallax.enabled) return;
    setTranslate();
  });
  on('setTransition', function (_swiper, duration) {
    if (!swiper.params.parallax.enabled) return;
    setTransition(duration);
  });
}
export { Parallax as default };